<div class="quote-visualization">
  <div class="visual-sales-tool-container">
    <div class="visual-sales-tool-container__header">
      <h4 class="visual-sales-tool-container__heading">Visualize your Whole Life policy's value over time</h4>
    </div>
    <visual-sales-tool
      *ngIf="!!safeInviteInfo"
      [template]="'client'"
      [showRidersDisclaimer]="false"
      [safeInviteInfo]="safeInviteInfo"
    ></visual-sales-tool>
  </div>
  <div class="quote-visualization-footer">
    <div class="quote-visualization-footer__disclaimer-paragraph">
      These illustrated amounts are not guaranteed. They include dividends which are neither estimates nor guarantees,
      but are based on the {{ yearForIllustration }} dividend schedule. Dividends in future years may be higher or
      lower, depending on the company’s actual experience. For this reason, we strongly recommend you look at a lower
      schedule illustration available upon request.
    </div>
    <div class="quote-visualization-footer__disclaimer-paragraph">
      This illustration is not valid unless accompanied or preceded by a MassMutual Whole Life {{ term }} Basic Life
      Insurance Illustration.
      <span>Refer to the</span>
      <a
        href="javascript:void(0)"
        id="vst-get-basic-illustration"
        class="quote-visualization-footer__view-basic-illustration"
        (click)="getBasicIllustrationPdf()"
      >
        Basic Illustration
      </a>
      <span>for guaranteed elements, assumptions, explanations and other important information.</span>
    </div>
    <div class="quote-visualization-footer__subheading">Questions? Contact your Financial Professional</div>
    <div class="quote-visualization-footer__advisor-contact">
      <span>{{ advisorFirstName }} {{ advisorLastName }}</span>
      <span>({{ advisorProducerId }}) |</span>
      <span>{{ advisorAgencyName }} |</span>
      <span>{{ advisorStreet }}, {{ advisorCity }}, {{ advisorState }} {{ advisorZipcode }} |</span>
      <span>
        <a href="tel:{{ advisorPhoneLink }}">{{ advisorPhone }}</a>
      </span>
    </div>
  </div>
</div>
